import { Stack } from 'src/components/mui';
//@ts-ignore
import React from 'react';

type Props = {
  main?: string;
  secondary: string;
};

export default function MouseAsset({ main = 'fa-computer-mouse', secondary }: Props) {
  return (
    <Stack spacing={2}>
      <i style={{ fontSize: '30px' }} className={`fa-regular ${secondary}`} />
      <i style={{ fontSize: '100px' }} className={`fa-thin ${main}`} />
    </Stack>
  );
}
